import { API_BASE_URL } from '../config';


export const getFilteredPlaces = async ({
  text,
  lang,
  page,
  perPage,
  from,
  to,
  capacity,
  min_price,
  max_price,
  instant_booking,
  type,
  order,
  style,
  order_type,
  usages = [],
  price_type = [],
  options = {}, // Changed from an array to an object
  city,
  country,
  postal_code,

} = {}) => {
  // Create base query parameters only if values are provided
  const queryParams = new URLSearchParams();

  // Append only if values are present
  if (text) queryParams.append("text", text);
  if (style) queryParams.append("style", style.toString());

  if (lang) queryParams.append("lang", lang === "uk" ? "en" : lang);
  if (page) queryParams.append("page", page.toString());
  if (perPage) queryParams.append("perPage", perPage.toString());
  if (from) queryParams.append("from", from);
  if (to) queryParams.append("to", to);
  if (capacity) queryParams.append("capacity", capacity.toString());
  if (min_price) queryParams.append("min_price", min_price.toString());
  if (max_price) queryParams.append("max_price", max_price.toString());
  if (price_type.length) queryParams.append("price_type", price_type.join(',')); // Changed to join if it’s an array
  if (instant_booking) queryParams.append("instant_booking", instant_booking.toString());
  if (type) queryParams.append("type", type);
  if (order) queryParams.append("order", order);
  if (order_type) queryParams.append("order_type", order_type);
  city && queryParams.append("city", city);
  country && queryParams.append("country", country);
  postal_code && queryParams.append("postal_code", postal_code);
  
 // Handle usages array
const filteredUsages = usages.filter(usage => usage !== "");
if (filteredUsages.length > 0) {
    filteredUsages.forEach((usage) => queryParams.append("usages[]", usage));
}

  if (Object.keys(options).length > 0) {
    
    const encodedOptions = encodeURIComponent(JSON.stringify(options));
    queryParams.append('options', encodedOptions);
}


  // Construct the URL with query parameters
  const url = `${API_BASE_URL}places?${queryParams.toString()}`;

  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    // Check if the response is ok (status in the range 200-299)
    if (!response.ok) {
      const errorData = await response.json();
      console.error("Error fetching places:", errorData);
      throw new Error(`Error: ${errorData.message || "Unknown error"}`);
    }

    const data = await response.json();
    
    // Check if the response contains the expected data structure
    if (!data || !data.data) {
      throw new Error("Invalid response structure");
    }

    console.log(data);
    return data; // Return the data from the API response
  } catch (error) {
    // Log the error and rethrow it
    console.error("Error fetching places:", error.message);
    throw error;
  }
};

